import { AppBrand } from '@shared/config'

interface AppBrandReturn {
  isSmartestMinds: boolean
}

export const useAppBrand = (): AppBrandReturn => ({
  isSmartestMinds: useRuntimeConfig().public.brand === AppBrand.SmartestMinds,
})
